import { render, staticRenderFns } from "./ShopperOverviewSection.vue?vue&type=template&id=2f83ae1e&scoped=true"
import script from "./ShopperOverviewSection.vue?vue&type=script&lang=js"
export * from "./ShopperOverviewSection.vue?vue&type=script&lang=js"
import style0 from "./ShopperOverviewSection.vue?vue&type=style&index=0&id=2f83ae1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f83ae1e",
  null
  
)

export default component.exports